import React, { useEffect, useMemo, useState } from 'react';
import { Loading } from '@virtidev/toolbox';
import PageLoadError from '@base/components/PageLoadError';
import { useQuery } from '@apollo/client';
import { REACT_VIRTUAL_HUMAN_SHARE_TOKEN } from '@core/components/VirtualHumans/PDWebPlayerContent/PDWebPlayerPageContent.query';
import { useParams } from 'react-router-dom';
import VirtualCoachChat from '@core/pages/admin/virtual-humans/VirtualCoachPagePublic/components/VirtualCoachChat';
import { READ_VIRTUAL_HUMAN } from './VirtualCoachPagePublic.query';

const VirtualCoachPagePublic = () => {
  // const { sharetoken } = useParams();
  const { ssVirtualHumanID } = useParams();
  const [loaded, setLoaded] = useState(false);

  // const { data, loading, error } = useQuery(REACT_VIRTUAL_HUMAN_SHARE_TOKEN, {
  //   variables: { sharetokenHeader: sharetoken, sharetoken },
  //   skip: !sharetoken,
  // });

  const { data, loading, error, refetch } = useQuery(READ_VIRTUAL_HUMAN, {
    variables: {
      ID: ssVirtualHumanID,
    },
  });

  const virtualhuman = useMemo(() => data?.readOneVirtualHuman, [data]);

  useEffect(() => {
    if (!virtualhuman) {
      return;
    }
    localStorage.setItem(
      'publicVirtualHumanAPI',
      virtualhuman.Organisation.VirtualHumanAPI
    );
    setLoaded(true);
  }, [virtualhuman]);

  if (loading || !loaded) {
    return <Loading />;
  }
  if (error) {
    return <PageLoadError graphQLErrorObj={error} />;
  }

  if (!virtualhuman) {
    return null;
  }

  return (
    <>
      <VirtualCoachChat virtualHuman={virtualhuman} />
    </>
  );
};

export default VirtualCoachPagePublic;
